<script setup>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import BackButton from '../../../components/widgets/BackButton.vue';
import Icon from 'dashboard/components-next/icon/Icon.vue';
import { getSettingsPageTitleIcon } from 'dashboard/helper/settingsRouteIcons';

const props = defineProps({
  headerTitle: {
    default: '',
    type: String,
  },
  titleIcon: {
    default: '',
    type: String,
  },
  showBackButton: { type: Boolean, default: false },
  backUrl: {
    type: [String, Object],
    default: '',
  },
  backButtonLabel: {
    type: String,
    default: '',
  },
});

const route = useRoute();

const resolvedTitleIcon = computed(() => {
  const explicit = props.titleIcon?.trim();
  if (explicit) return explicit;
  if (props.headerTitle?.trim()) return getSettingsPageTitleIcon(route.name);
  return '';
});
</script>

<template>
  <div
    class="flex min-h-[3.5rem] items-center justify-between bg-n-surface-1 px-8 py-2 md:px-10"
  >
    <h1 class="mb-0 flex items-center text-2xl text-n-slate-12">
      <BackButton
        v-if="showBackButton"
        :button-label="backButtonLabel"
        :back-url="backUrl"
        class="shrink-0 ltr:mr-4 rtl:ml-4"
      />

      <div
        v-if="resolvedTitleIcon"
        class="flex size-10 shrink-0 items-center justify-center rounded-xl outline outline-1 outline-n-weak -outline-offset-1 ltr:mr-3 rtl:ml-3"
      >
        <Icon :icon="resolvedTitleIcon" class="size-5 text-n-slate-12" />
      </div>

      <span class="text-xl font-medium text-n-slate-12">
        {{ headerTitle }}
      </span>
    </h1>
  </div>
</template>
